























































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Table } from '@/components/bwaff';
import moment from 'moment';
import { forEach } from 'lodash';

const numeralFormat = require('numeral');

@Component({
  components: {
    DataTable: Table,
  }
})
export default class ReferralBalance extends Vue {
  @Prop()
  api: any;

  @Prop({default: '$ 0,0.00'})
  format: string;

  @Prop({default:'DD MMM YYYY hh:mm'})
  dateFormat!: string;

  rows: any[] = [];
  rowsOnPage: number = 20;
  totalRows: number = 0;
  footer: any = {};
  referralPaymentAccount: string = '';
  referralBalance: any = '';

  pagination: any = {
    descending:null,
    sortBy:null,
    rowsPerPage: this.rowsOnPage
  };

  getDescendingFormatted(descending: boolean | null){
    switch (descending){
      case true:
        return 'desc';
      case false:
        return 'asc';
      case null:
      default:
        return null;
    }
  }

  get headers() {
    return [
      {text: this.t('Transaction ID'), value: 'id', sortable: true},
      {text: this.t('Date'), value: 'created', sortable: true},
      {text: this.t('Type'), value: 'operation', sortable: true},
      {text: this.t('Sum'), value: 'sum', sortable: true}
    ];
  }

  formatters: any = {
    operation: (h: Function, c: any, ctx: any, x: any) => {
      let textOperation = ''
      if(x.operation === 'payout'){
        textOperation = ctx.t('Payout')
      }
      if(x.operation === 'add'){
        textOperation = ctx.t('Commission fee')
      }
      return h('span', [textOperation])
    },
    sum:(h: Function, c: any, ctx: any, x: any) => {
      if (x.sum) {
        let count = numeralFormat(x.sum / 100).format(this.format);
        return h('span', [count])
      }
    }
  };

  paymentInformation() {
    this.bus.emit('open-dialog', { name: 'PaymentInformation' });
  }

  fillForm(val: any){
    this.referralPaymentAccount = val.referralPaymentAccount;
    this.referralBalance = `$  ${numeralFormat(val.referralBalance/100).format('0,0.00')}`
  }

  mounted(){
    this.fillForm(this.$store.state.user);
  }

  @Watch('api.dataBalance')
  dataReceived(data: any) {
    if(data.items) {
      this.rows = forEach(data.items, e => {
        e.created = e.created ? moment.utc(e.created).tz(this.$store.state.user.defaultTimezone).format(this.dateFormat) : '';
        return e;
      });
      this.totalRows = data.count;
    }
    this.footer = {
      id: this.t('Total transactions') + ': ' + (data.count || 0),
      operation: '',
      type: '',
      sum: '',
    }
  }

  @Watch('pagination')
  paginationUpdated(currentState:any,previousState:any){
    const {page, rowsPerPage, descending, sortBy }= currentState;
    const orderDir = this.getDescendingFormatted(descending)

    this.api.getBalance({
      offset:(page-1)*rowsPerPage,
      limit:rowsPerPage,
      orderDir,
      orderBy:sortBy
    });
  }

  @Watch('$store.state.user')
  dataProfileReceived(data: any) {
    this.fillForm(data);
  }
}
